import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled/macro";

const rotation = keyframes`
    from {
        rotate: 0;
    }

    to {
        rotate: 360deg;
    }
`;

export const ListItem = styled.li`
  --secondary-color: ${({ theme }) => theme.colors.secondaryColor};
  --background-color: var(--secondary-color);
  --icon-color: #fff;

  position: relative;

  button,
  a {
    width: 2.2rem;
    height: 2.2rem;

    padding: 0;

    border: 1px solid var(--secondary-color);
    border-radius: 50%;
    display: grid;
    place-items: center;
    background-color: var(--background-color);
    color: var(--icon-color);

    cursor: pointer;
  }

  svg {
  }

  &:first-of-type {
    z-index: 15;
  }

  &:not(:first-of-type) {
    --background-color: #fff;
    --icon-color: var(--secondary-color);
  }

  button:hover,
  a:hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
    transition: background-image 0.2s ease-in-out;
  }
`;

export const Container = styled.ul<{ toggled: boolean }>`
  display: none;

  @media screen and (min-width: 1024px) {
    list-style: none;
    position: absolute;
    right: -3rem;
    top: 0;

    z-index: 10;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    gap: 0.5rem;

    ${ListItem} {
      transition: translate 0.5s ease-in, rotate 0.5s ease-in;

      &:first-of-type {
        ${({ toggled }) =>
          toggled &&
          css`
            rotate: 360deg;
          `}
      }

      &:nth-of-type(2) {
        z-index: 14;
        translate: 0 -2.7rem;
      }
      &:nth-of-type(3) {
        z-index: 13;
        translate: 0 -5.4rem;
      }
      &:nth-of-type(4) {
        z-index: 12;
        translate: 0 -8.1rem;
      }
      &:nth-of-type(5) {
        z-index: 11;
        translate: 0 -10.8rem;
      }

      ${({ toggled }) =>
        toggled &&
        css`
          translate: 0 0 !important;
        `}
    }
  }
`;
